import React from "react";

function HealthBar({ score }) {
  const color = score >= 90 ? "#17A589" : score >= 70 ? "#F39C12" : score > 0 ? "#C0392B" : "#BDC3C7";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ flex: 1, height: 6, background: "#ECF0F1", borderRadius: 3, overflow: "hidden", minWidth: 60 }}>
        <div
          style={{
            width: `${score}%`,
            height: "100%",
            background: color,
            borderRadius: 3,
            transition: "width 0.4s",
          }}
        />
      </div>
      <span style={{ fontSize: 12, color: color, fontWeight: 600, minWidth: 30 }}>
        {score > 0 ? score : "—"}
      </span>
    </div>
  );
}

export default HealthBar;
